import { MainKanbanCard } from '../main-kanban-card';
import OrderListChipBox from '../order-list-chip-box';
import { CustomKanbanColumn } from '../common/custom-kanban-column';

import { useCookingColumn } from './hooks';
import { AutoAcceptKanbanCard } from 'components/main-kanban-card/components';

export function CookingColumn({ hasAutoAccept = false }: Props) {
  const {
    text,
    ordersInCooking,
    numberOfOrdersInCooking,
    showEmptyTextOfOrders,
  } = useCookingColumn(hasAutoAccept);

  const renderOrderCard = order => {
    if (order?.isAutoAcceptNew) {
      return <AutoAcceptKanbanCard key={`cooking-${order.id}`} order={order} />;
    }
    return <MainKanbanCard key={`cooking-${order.id}`} order={order} />;
  };

  return (
    <CustomKanbanColumn
      Chip={<OrderListChipBox />}
      title={text.title}
      emptyText={text.noOrders}
      count={numberOfOrdersInCooking}
      showEmpty={showEmptyTextOfOrders}
    >
      {ordersInCooking.map(renderOrderCard)}
    </CustomKanbanColumn>
  );
}

type Props = {
  hasAutoAccept: boolean;
};
